module.exports = __webpack_public_path__ + "img/material-title-sm.3da2f8e1.png";